var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 40 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1429 0H2.85714C2.09938 0 1.37266 0.31607 0.836838 0.87868C0.301019 1.44129 0 2.20435 0 3V27C0 27.7956 0.301019 28.5587 0.836838 29.1213C1.37266 29.6839 2.09938 30 2.85714 30H37.1429C37.9006 30 38.6273 29.6839 39.1632 29.1213C39.699 28.5587 40 27.7956 40 27V3C40 2.20435 39.699 1.44129 39.1632 0.87868C38.6273 0.31607 37.9006 0 37.1429 0V0ZM34 3L20 13.17L6 3H34ZM2.85714 27V4.365L19.1857 16.23C19.4249 16.4042 19.709 16.4975 20 16.4975C20.291 16.4975 20.5751 16.4042 20.8143 16.23L37.1429 4.365V27H2.85714Z",
    fill: "#4A3AFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b35684ba1064daeb3d64ccdf731096a8.svg";
export { ForwardRef as ReactComponent };